import { forwardRef } from 'react';
import { FooterBaseSaas } from './FooterBaseSaas';
import type { FooterVariant, RootFooterProps } from './types';

export type FooterProps = Omit<RootFooterProps, 'variant'>;

const FooterVariants: Record<
  FooterVariant,
  React.ForwardRefExoticComponent<
    Omit<FooterProps, 'ref'> & React.RefAttributes<HTMLDivElement>
  >
> = {
  FooterBaseSaas: FooterBaseSaas,
};

export const Footer = forwardRef<HTMLDivElement, RootFooterProps>(
  ({ variant, children, ...props }, ref) => {
    const FooterComp = FooterVariants[variant];

    return (
      <FooterComp {...props} ref={ref}>
        {children}
      </FooterComp>
    );
  },
);
